import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { getFxEnabledRoles } from 'common/utils/user';

import { protocolDesignerSubTabParam } from './utils/routes';

export const PROTOCOL_DESIGNER_PATH = `/study/:studyId/:studyDetails?/:${protocolDesignerSubTabParam}?`;

export const routes = [
    {
        component: lazy(() => import('module/protocoldesigner/protocol_designer.page')),
        permissions: ['Study_Create', 'Study_Edit', 'Study_Delete', 'Study_Read'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
    },
    {
        component: lazy(() => import('module/protocoldesigner/protocol_designer.page')),
        permissions: ['Study_Create', 'Study_Edit', 'Study_Delete', 'Study_Read'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.Librarian,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
        path: PROTOCOL_DESIGNER_PATH,
    },
];
